const refinementsGroup = {
    RefinementsGroup: {
        baseStyle: ({isSearch}: {isSearch: boolean}) => ({
            wrapper: {
                pos: 'relative',
                w: {base: 'auto', md: 'full'},
                py: !isSearch && {base: 0, md: 'spacing.2'},
                gap: 'spacing.6',
                borderBottom: !isSearch ? '1px solid' : {md: '1px solid'},
                justifyContent: 'center',
                borderColor: {base: 'color.border.transparent', md: 'color.border.grey.300'},
                zIndex: 'dropdown',
            },
            filterControls: {
                pos: {base: 'fixed', md: 'unset'},
                bottom: 0,
                left: 0,
                right: 0,
                flex: 1,
                justifyContent: 'space-between',
                zIndex: {base: 'banner', md: 0},
                gap: 0,
                transition: 'opacity 0.2s ease-in-out',
            },
            hiddenFilterControls: {
                opacity: 0,
            },
            gridControls: {
                w: {base: '100%', sm: 'auto'},
                justifyContent: {base: 'flex-end', md: 'center'},
                py: {base: 'spacing.2', sm: 0},
            },
        }),
    },
}

export default refinementsGroup
